// extracted by mini-css-extract-plugin
module.exports = {"menu-item":"NavigationLink_menu-item__CbwhE","navigation-link":"NavigationLink_navigation-link__3m6w6","active":"NavigationLink_active__1y9Gj"};